mag_data_confirm = {
    init: function () {
        $('a[data-confirm]').unbind('click');
        $('a[data-confirm]').click(function (ev) {
            var href = $(this).attr('href');
            var okFunc = $(this).data("func");
            $('#dataConfirmModal').find('.modal-body').text($(this).attr('data-confirm'));
            $('#dataConfirmOK').unbind('click');
            $('#dataConfirmOK').click(function () {
                $('#dataConfirmModal').modal('hide');
                if (okFunc !== null && okFunc !== '' && ((typeof okFunc) !== 'undefined')) {
                    if (typeof okFunc !== 'function')
                        eval(okFunc);
                    else
                        eval(okFunc());
                } else {
                    window.location = href;
                }
            });
            $('#dataConfirmModal').modal('show');
            return false;
        });
    }
};
magalert = {
    errorMessage: function (message) {
        toastr.clear();
        toastr.error(message, 'Error', { timeOut: 0, progressBar: false, showMethod: 'slideDown', positionClass: 'toast-top-center' });
    },
    successMessage: function (message) {
        toastr.clear();
        toastr.success(message, 'Success', { timeOut: 5000, progressBar: true, showMethod: 'slideDown', positionClass: 'toast-top-center' });
    },
    clearMessagess: function () {
        toastr.clear();
    },
    communicationError: function () {
        magalert.errorMessage("Unable to communicate with the server, please try again");
    },
    ajaxMessage: function (magRet) {
        if (magRet.data === undefined && magRet.Data !== undefined) {
            if (magRet.Message !== null && magRet.Message.length > 0) {
                if (magRet.Success) {
                    magalert.successMessage(magRet.Message);
                } else {
                    magalert.errorMessage(magRet.Message);
                }
            }
        } else if (magRet.data !== undefined) {
            if (magRet.message !== null && magRet.message.length > 0) {
                if (magRet.success) {
                    magalert.successMessage(magRet.message);
                } else {
                    magalert.errorMessage(magRet.message);
                }
            }
        }
    }
};
comhandler = {
    transportType: null,
    logger: null,
    sigHub: null,
    sigConnection: null,
    init: function (message) {
        var stickyStart = function () {
            setTimeout(function () {
                console.log('Starting SignalR');
                comhandler.sigConnection.start()
                    .catch(function (err) {
                        console.log('Connection Error: ' + err);
                        console.log('Retrying...');
                        stickyStart();
                    });
            }, 5000);
        };
        comhandler.transportType = signalR.TransportType.WebSockets;
        comhandler.logger = new signalR.ConsoleLogger(signalR.LogLevel.Information);
        comhandler.sigHub = new signalR.HttpConnection('https://' + document.location.host + '/devicesupport', { transport: comhandler.transportType, logger: comhandler.logger });
        comhandler.sigConnection = new signalR.HubConnection(comhandler.sigHub, comhandler.logger);
        comhandler.sigConnection.onclose(function (error) {
            stickyStart();
        });
        stickyStart();
    }
};
mediahandler = {
    transportType: null,
    logger: null,
    sigHub: null,
    sigConnection: null,
    init: function (message) {
        var stickyStart = function () {
            setTimeout(function () {
                console.log('Starting SignalR mediahandler');
                mediahandler.sigConnection.start()
                    .catch(function (err) {
                        console.log('Connection Error mediahandler: ' + err);
                        console.log('Retrying mediahandler...');
                        stickyStart();
                    });
            }, 5000);
        };
        mediahandler.transportType = signalR.TransportType.WebSockets;
        mediahandler.logger = new signalR.ConsoleLogger(signalR.LogLevel.Information);
        mediahandler.sigHub = new signalR.HttpConnection('https://' + document.location.host + '/mediasupport', { transport: comhandler.transportType, logger: comhandler.logger });
        mediahandler.sigConnection = new signalR.HubConnection(mediahandler.sigHub, mediahandler.logger);
        mediahandler.sigConnection.onclose(function (error) {
            stickyStart();
        });
        mediahandler.sigConnection.on('mediaUpdate', function (mediaInfos, companyId) {
            if (companyId === $("#CompanyKey").val()) {
                $(window).trigger('mediaUpdate', [mediaInfos]);
            }
        });
        mediahandler.sigConnection.on('mediaDelete', function (mediaIds, companyId) {
            if (companyId === $("#CompanyKey").val()) {
                $(window).trigger('mediaDelete', [mediaIds]);
            }
        });
        stickyStart();
    }
};
deviceSupporthandler = {
    transportType: null,
    logger: null,
    sigHub: null,
    sigConnection: null,
    init: function (message) {
        var stickyStart = function () {
            setTimeout(function () {
                console.log('Starting SignalR deviceSupporthandler');
                deviceSupporthandler.sigConnection.start()
                    .catch(function (err) {
                        console.log('Connection Error deviceSupporthandler: ' + err);
                        console.log('Retrying deviceSupporthandler...');
                        stickyStart();
                    });
            }, 5000);
        };
        deviceSupporthandler.transportType = signalR.TransportType.WebSockets;
        deviceSupporthandler.logger = new signalR.ConsoleLogger(signalR.LogLevel.Information);
        deviceSupporthandler.sigHub = new signalR.HttpConnection('https://' + document.location.host + '/devicesupport', { transport: comhandler.transportType, logger: comhandler.logger });
        deviceSupporthandler.sigConnection = new signalR.HubConnection(deviceSupporthandler.sigHub, deviceSupporthandler.logger);
        deviceSupporthandler.sigConnection.onclose(function (error) {
            stickyStart();
        });
        deviceSupporthandler.sigConnection.on('pingResults', function (flag, message) {
            console.log('received pingResults message');
            console.log(message);
            var evt = $.Event('pingResults', { 'resp': message });
            $(window).trigger(evt);
        });
        stickyStart();
    },
    invoke: function(connection, method) {
        var argsArray = Array.prototype.slice.call(arguments);
        connection.invoke.apply(connection, argsArray.slice(1))
            .then(function (result) {
                console.log("invocation completed successfully: " + (result === null ? '(null)' : result));
            })
        .catch(function (err) {
        });
    },
    sendSupport: function (deviceId, command) {
        deviceSupporthandler.invoke(deviceSupporthandler.sigConnection, 'initiateSupport', deviceId, command, '');
    }
};
magdatepicker = {
    init: function (root, watermark) {
        $(root).ejDatePicker({
            dateFormat: "MM/dd/yyyy",
            watermarkText: watermark,
            height: 46,
            width: "100%",
            enableStrictMode: true
        });
        $(root).change(function () {
            var eVal = $(this).val();
            if (!isNaN(eVal)) {
                if (eVal.length === 8) {
                    $(this).val(eVal.substring(0, 2) + '/' + eVal.substring(2, 4) + '/' + eVal.substring(4, 8));
                } else if (eVal.length === 6) {
                    if (parseInt(eVal.substring(4, 6)) > 25) {
                        $(this).val(eVal.substring(0, 2) + '/' + eVal.substring(2, 4) + '/19' + eVal.substring(4, 6));
                    } else {
                        $(this).val(eVal.substring(0, 2) + '/' + eVal.substring(2, 4) + '/20' + eVal.substring(4, 6));
                    }
                }
            }
        });
    }
};
$(document).ready(function () {
    $("#help-toggle").click(function () {
        $('body').chardinJs('start');
    });
    mag_data_confirm.init();
    comhandler.init();
    // probably shouldn't call this on every page
    // since most pages won't be using it anyways
    mediahandler.init();
});
